// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"b2416bf0","347":"0c0054c1","453":"a4631182","565":"2dd846b7","869":"c95fc619","974":"d3e9c4b6"}[chunkId] + ".chunk.js";
};